import { GetBaseArgs } from "@/lib/baseListOptions";

/**
 * @function ApiClient#GetMaintenanceReportList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} listOptions
 * @param {any} options = {}
 */
export async function GetMaintenanceReportList(cid, listOptions, options = {}) {
  const args = GetBaseArgs(listOptions);
  const url = Object.keys(args).reduce((acc, value, index) => {
    return acc + (index === 0 ? "?" : "&") + value + args[value];
  }, `/community/${cid}/maintenance/reports`);
  return await this._get(url, options);
}

/**
 * @function ApiClient#GetInternalWorker
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetInternalWorker(cid, options = {}) {
  return await this._get(`/community/${cid}/internal_people_list`, options);
}

/**
 * @function ApiClient#GetExternalWorker
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetExternalWorker(cid, options = {}) {
  return await this._get(`/community/${cid}/vendor_list`, options);
}

/**
 * @function ApiClient#GetReportRelated
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id = ""
 * @param {any} options = {}
 */
export async function GetReportRelated(cid, id = "", options = {}) {
  return await this._get(`/community/${cid}/maintenance/report/${id}/related`, options);
}
